import Quill from 'quill';
import {MatDialog} from '@angular/material/dialog';
import {MobileService} from 'src/app/core/page/mobile.service';
import {WIKI_ITEM_DIALOG_SETTINGS} from './../../../wiki/shared/wiki.constants';
import {
  WikiViewArticleDialogComponent,
  WikiViewDataProps,
} from './../../../wiki/wiki-view-article-dialog/wiki-view-article-dialog.component';
import {WikiViewArticleComponent} from 'src/app/wiki/wiki-view-article/wiki-view-article.component';
import {OphDrawerService} from './../../../shared/design/oph-drawer/oph-drawer.service';

const Link = Quill.import('formats/link');

export class CustomQuillLinkHandler extends Link {
  static ComponentInstance: ComponentInstance;
  static type: 'dialog' | 'drawer' = 'drawer';
  Z;

  static create(value: string) {
    const node: HTMLElement = super.create(value);
    if (value.includes('/wiki/view/')) {
      node.addEventListener('click', event => {
        event.preventDefault();
        this.handleWikiClick(value, node);
      });
    }
    return node;
  }

  static handleWikiClick(url: string, node: HTMLElement) {
    const urlObj = new URL(url);
    const pathSegments = urlObj.pathname.split('/');
    const itemId = pathSegments[pathSegments.length - 1];

    switch (this.type) {
      case 'dialog': {
        if (this.ComponentInstance?.dialog) {
          this.ComponentInstance.dialog.open(WikiViewArticleDialogComponent, {
            data: {itemId: itemId} as WikiViewDataProps,
            ...WIKI_ITEM_DIALOG_SETTINGS,
            autoFocus: this.ComponentInstance.mobileService.isMobilePlatform() ? false : undefined,
          });
        }
        break;
      }
      case 'drawer': {
        if (this.ComponentInstance.drawerService) {
          WikiViewArticleComponent.prototype.itemId = itemId;

          this.ComponentInstance.drawerService.setDrawerContext({
            hideCloseButton: true,
            hideBackdrop: true,
            hideScrollbar: false,
          });
          this.ComponentInstance.drawerService.openDrawer();
          this.ComponentInstance.drawerService.loadComponent(WikiViewArticleComponent);
        } else {
          console.error('Drawer service is not defined.');
        }
        break;
      }
      default: {
        return node;
      }
    }
  }
}

export function registerCustomQuillLinkHandler() {
  Quill.register(CustomQuillLinkHandler, true);
}

export function unregisterCustomQuillLinkHandler() {
  Quill.register(Link, true);
}

export interface ComponentInstance {
  dialog: MatDialog;
  drawerService: OphDrawerService;
  mobileService: MobileService;
}

export function setCustomQuillLinkHandlerInstance(instance: ComponentInstance, type: 'dialog' | 'drawer' = 'drawer') {
  CustomQuillLinkHandler.ComponentInstance = instance;
  CustomQuillLinkHandler.type = type;
}
